export default {
  data: () => ({
    applicationErrorObject: undefined
  }),
  methods: {
    handleCreateApplicationError: function(error) {
      if (error.response && error.response.data) {
        this.applicationErrorObject = error.response.data;
      } else if (error instanceof Error) {
        this.applicationErrorObject = this.generateApplicationErrorMessageObject(
          error
        );
      }
    },
    handleUpdateApplicationError: function(error) {
      this.handleCreateApplicationError(error);
    },
    handleGetApplicationError: function(error) {
      this.handleCreateApplicationError(error);
    },
    generateApplicationErrorMessageObject(error) {
      return { error: { message: { value: error.message } } };
    },
    clearApplicationErrorMessage: function() {
      this.applicationErrorObject = undefined;
    }
  }
};
